import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import LanguageIcon from "@mui/icons-material/Language";
import NotificationsIcon from "@mui/icons-material/Notifications";
import WidgetsIcon from "@mui/icons-material/Widgets";
import Badge from "@mui/material/Badge";
import { format } from "date-fns";
import Pusher from "pusher-js";
import ClipLoader from "react-spinners/ClipLoader";
import NotificationService from "../Services/notification.service";

import {
  Button,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Toolbar,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import AuthService from "../Services/auth.service";
const Navbar = ({ onMenuClick }) => {
  const { t, i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [notificationAnchorEl, setNotificationAnchorEl] = useState(null);
  const [profileAnchorEl, setProfileAnchorEl] = useState(null); // New state for profile menu
  const [userInfo, setUserInfo] = useState(() => {
    return JSON.parse(localStorage.getItem("user")) || [];
  });
  const [logoutLoading, setLogoutLoading] = useState(false);

  const [selectedLanguage, setSelectedLanguage] = useState(i18n.language);
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const formatTimestamp = (timestamp) => {
    return format(new Date(timestamp), "MMM d, yyyy h:mm a");
  };

  const changeLanguage = (language) => {
    i18n.changeLanguage(language);
  };
  const handleLanguageMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const languageOptions = [
    { code: "en", label: "English" },
    { code: "አማ", label: "አማርኛ" },
    // { code: "or", label: "afaan oromo" },
  ];

  const handleLanguageMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleLanguageMenuClose = () => {
    setAnchorEl(null);
  };
  const handleLanguageSelect = (language) => {
    setSelectedLanguage(language);
    changeLanguage(language);
    handleLanguageMenuClose();
  };
  const navigate = useNavigate();

  const handleLogout = () => {
    setLogoutLoading(true);

    try {
      setTimeout(() => {
        AuthService.logout();
        navigate("/login");
        setLogoutLoading(false);
      }, 2000);
    } catch (error) {
      console.log(error);
      setLogoutLoading(false);
    }
  };

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const notification = await NotificationService.getNotificationById(
          userInfo.user?.id
        );
        setNotifications(notification);
        const unreadNotifications = notification.filter(
          (notification) => notification.read === "0"
        );
        console.log(unreadNotifications.length);
        setUnreadCount(unreadNotifications.length);
      } catch (error) {
        console.error("Error fetching notifications:", error.message);
      }
    };

    fetchNotifications();
  }, []);

  useEffect(() => {
    async function fetchUsers() {
      localStorage.setItem("user", JSON.stringify(userInfo));
    }
    fetchUsers();
  }, [userInfo]);

  const handleNotificationClick = (event) => {
    setNotificationAnchorEl(event.currentTarget);
    setUnreadCount(0);
    markAllNotificationsAsSeen();
  };

  const markAllNotificationsAsSeen = async () => {
    const updatedNotifications = notifications.map((notification) => ({
      ...notification,
      seen: true,
    }));
    try {
      await NotificationService.markNotificationAsRead(userInfo.user?.id);
      setNotifications(updatedNotifications);
    } catch (e) {
      console.error(e);
    }
  };

  const handleNotificationClose = () => {
    setNotificationAnchorEl(null);
  };

  const handleProfileMenuClick = (event) => {
    setProfileAnchorEl(event.currentTarget);
  };

  const handleProfileMenuClose = () => {
    setProfileAnchorEl(null);
  };

  const renderNotificationMessage = (notification) => {
    let messageKey;
    let messageData;

    switch (notification.type) {
      case "Maintenance Request Created":
        try {
          const parsedData = JSON.parse(notification.data);
          messageData =
            parsedData?.notification_message ||
            "Default maintenance request message";
          messageKey = "notification.maintenanceRequestCreated";
        } catch (e) {
          console.error("Error parsing notification data:", e);
          messageData = "Error in maintenance request data";
          messageKey = "notification.error";
        }
        break;

      case "Tenant Payment Attached":
        messageData = notification.data;
        messageKey = "notification.tenantPaymentAttached";
        break;

      case "Tenant Payment Approved":
        messageData = notification.data;
        messageKey = "notification.tenantPaymentApproved";
        break;

      case "Tenant Payment Rejected":
        messageData = notification.data;
        messageKey = "notification.tenantPaymentRejected";
        break;

      default:
        messageData = "Unknown notification type";
        messageKey = "notification.unknown";
    }

    return t(messageKey, { unitNumber: messageData });
  };

  useEffect(() => {
    Pusher.logToConsole = true;
    const pusher = new Pusher(process.env.REACT_APP_PUSHER_APP_KEY, {
      cluster: process.env.REACT_APP_PUSHER_APP_CLUSTER,
      encrypted: true,
    });

    const channel = pusher.subscribe("notification-channel");

    channel.bind("notification-event", (data) => {
      try {
        console.log("Data", data);
      } catch (error) {
        console.log("error");
      }
    });

    return () => {
      pusher.unsubscribe("notification-channel");
    };
  }, []);

  return (
    <div position="fixed" className="bg-slate-50">
      <Toolbar>
        <IconButton
          edge="start"
          color="inherit"
          aria-label="menu"
          onClick={onMenuClick}
          sx={{ mr: 2 }}
        >
          <WidgetsIcon style={{ color: "#4d7fb5" }} />
        </IconButton>
        <Grid
          container
          justifyContent="flex-end"
          alignItems="center"
          spacing={1.5}
        >
          <Grid item>
            <IconButton onClick={handleNotificationClick}>
              <Badge badgeContent={unreadCount} color="secondary">
                <NotificationsIcon />
              </Badge>
            </IconButton>
            <Menu
              anchorEl={notificationAnchorEl}
              open={Boolean(notificationAnchorEl)}
              onClose={handleNotificationClose}
            >
              {notifications.length !== 0 ? (
                notifications.map((notification) => (
                  <MenuItem key={notification.id}>
                    <div>
                      {notification.type === "Tenant Payment Attached" ? (
                        <a href={`/home/payment`}>
                          <div>{renderNotificationMessage(notification)}</div>
                          <div style={{ fontSize: "0.75rem", color: "gray" }}>
                            {notification.created_at
                              ? formatTimestamp(notification.created_at)
                              : "Unknown time"}
                          </div>
                        </a>
                      ) : (
                        <a href={`/home/maintenance/request`}>
                          <div>{renderNotificationMessage(notification)}</div>
                          <div style={{ fontSize: "0.75rem", color: "gray" }}>
                            {notification.created_at
                              ? formatTimestamp(notification.created_at)
                              : "Unknown time"}
                          </div>
                        </a>
                      )}
                    </div>
                  </MenuItem>
                ))
              ) : (
                <MenuItem>{t("notification.noNotification")}</MenuItem>
              )}
            </Menu>
          </Grid>
          <Grid item>
            <Button
              startIcon={<LanguageIcon />}
              onClick={handleLanguageMenuClick}
            >
              {selectedLanguage}
            </Button>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleLanguageMenuClose}
            >
              {languageOptions.map((option) => (
                <MenuItem
                  key={option.code}
                  onClick={() => handleLanguageSelect(option.code)}
                >
                  {option.label}
                </MenuItem>
              ))}
            </Menu>
          </Grid>

          <Grid item>
            {logoutLoading ? (
              <ClipLoader
                color="#4d7fb5"
                loading={logoutLoading}
                data-testid="loader"
                size={30}
              />
            ) : (
              <Button
                // style={{ color: "#fff" }}
                startIcon={<ExitToAppIcon />}
                onClick={handleLogout}
              >
                {t("navbar.logout")}
              </Button>
            )}
          </Grid>
        </Grid>
      </Toolbar>
    </div>
  );
};

export default Navbar;
